<template>
  <div class="columns is-multiline">
    <p
      class="is-large has-text-grey-dark filters__result-text"
      aria-live="assertive"
      role="alert"
      v-html="resultText"
    ></p>
    <div class="services__filters-header column is-10 is-8-desktop">
      <h2 class="services__filters-title">Filters:</h2>
      <button class="services__reset" title="Reset filters" @click="updateFilters(true)">
        <span class="icon icon--reset"><reset-svg></reset-svg></span>
        <span>Reset Filters</span>
      </button>
    </div>
    <div class="column is-5 is-4-desktop">
      <div class="select is-grey-dark is-filter">
        <select
          aria-label="Filter services by service type"
          required
          v-model="selectedServiceType"
          @change="updateFilters()"
        >
          <option value="">{{ serviceTypes.name }}</option>
          <option
            v-for="service in serviceTypes.value"
            :key="service.id"
            :value="service.id"
          >
            {{ service.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="column is-5 is-4-desktop">
      <div class="select is-grey-dark is-filter">
        <select
          aria-label="Filter services by location"
          required
          v-model="selectedLocation"
          @change="updateFilters()"
        >
          <option value="">{{ locations.name }}</option>
          <option
            v-for="location in locations.value"
            :key="location.id"
            :value="location.id"
          >
            {{ location.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import ResetSvg from '@/components/svg/reset.vue';

export default {
  name: 'service-filter',
  components: { ResetSvg },
  props: {
    locations: Object,
    resultCount: Number,
    searchTerm: String,
    serviceTypes: Object,
  },
  computed: {
    selectedLocation: {
      get() {
        return this.$store.state.selectedLocation;
      },
      set(value) {
        this.$store.commit('setSelectedLocation', value);
      },
    },
    selectedServiceType: {
      get() {
        return this.$store.state.selectedServiceType;
      },
      set(value) {
        this.$store.commit('setSelectedServiceType', value);
      },
    },
    resultText() {
      const filters = this.searchTerm ? [this.searchTerm] : [];
      const service = this.serviceTypes.value.filter(item => item.id === this.selectedServiceType);
      if (service.length > 0) {
        filters.push(service[0].name);
      }
      const location = this.locations.value.filter(item => item.id === this.selectedLocation);
      if (location.length > 0) {
        filters.push(location[0].name);
      }
      const filterText = filters.length > 0 ? ` for <b>${filters.join('</b> and <b>')}</b>` : '';
      const results = this.resultCount === 1 ? 'result' : 'results';
      return `<b>${this.resultCount} ${results}</b>${filterText}`;
    },
  },
  methods: {
    /**
     * Emit update event to parent. Optionally clear filters before update
     * @param { Boolean } reset - If set, will clear the filters before emitting update
     */
    updateFilters(reset) {
      if (reset) {
        this.selectedServiceType = '';
        this.selectedLocation = '';
      }
      this.$emit('update-filter');
    },
  },
};
</script>
